import type { ComponentSchema } from "../../../../../schema-types";
import type { FieldSchema } from "../../../../../schema-types";
import { SLIDE_SCHEMA, SECTION_STYLE_FIELDS } from "../../_builder-constants";

/** Room-scene slides: the room tab label and the product its floating "In this room" card shows. */
const ROOM_SLIDE_SCHEMA: FieldSchema[] = [
  ...SLIDE_SCHEMA,
  { key: "room", label: "Room tab label", type: "string", help: "e.g. Bedroom. Falls back to the slide title." },
  { key: "productId", label: "Product in this room", type: "product-select", help: "Shown as a card on the photo. Hidden until a product is picked." },
];

export const schema: ComponentSchema = {
  type: "hero",
  label: "Hero Section",
  description: "The main attention-grabbing section at the top of the page.",
  supportedPages: ["home", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Room scene",
      fields: [
        { key: "slides", label: "Slides (one per room)", type: "array", itemSchema: ROOM_SLIDE_SCHEMA },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: true },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5000 },
      ],
    },
    {
      id: "v2",
      label: "V2 — Split with badge panel",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: SLIDE_SCHEMA },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: true },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5000 },
      ],
    },
    {
      id: "v3",
      label: "V3 — Collage",
      fields: [
        { key: "slides", label: "Slides (the next two fill the side tiles)", type: "array", itemSchema: SLIDE_SCHEMA },
      ],
    },
    {
      id: "v4",
      label: "V4 — Shondhya (dark room scene)",
      fields: [
        { key: "slides", label: "Slides (one per room)", type: "array", itemSchema: ROOM_SLIDE_SCHEMA },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
